import { db } from "../lib/firebase";
import {
  collection,
  addDoc,
  updateDoc,
  doc,
  getDocs,
  query,
  where,
  orderBy,
  Timestamp,
} from "firebase/firestore";

export interface Notification {
  id?: string;
  userId: string;
  type: "payment_pending" | "payment_approved" | "course_enrollment" | "general";
  title: string;
  message: string;
  read: boolean;
  metadata?: {
    courseId?: string;
    paymentId?: string;
    studentId?: string;
    studentName?: string;
    amount?: number;
    [key: string]: any;
  };
  createdAt: Date | Timestamp;
}

export const createNotification = async (
  userId: string,
  type: Notification["type"],
  title: string,
  message: string,
  metadata?: Notification["metadata"]
): Promise<string> => {
  const notificationData = {
    userId,
    type,
    title,
    message,
    read: false,
    metadata: metadata || {},
    createdAt: Timestamp.now(),
  };

  const docRef = await addDoc(collection(db, "notifications"), notificationData);
  return docRef.id;
};

export const getUserNotifications = async (userId: string): Promise<Notification[]> => {
  const q = query(
    collection(db, "notifications"),
    where("userId", "==", userId),
    orderBy("createdAt", "desc")
  );

  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => {
    const data = doc.data();
    return {
      id: doc.id,
      ...data,
      createdAt: data.createdAt instanceof Timestamp ? data.createdAt.toDate() : data.createdAt,
    } as Notification;
  });
};

export const markNotificationAsRead = async (notificationId: string): Promise<void> => {
  const notificationRef = doc(db, "notifications", notificationId);
  await updateDoc(notificationRef, {
    read: true,
  });
};

export const notifyInstructorOfPayment = async (
  instructorId: string,
  studentId: string,
  studentName: string,
  courseId: string,
  courseTitle: string,
  amount: number,
  paymentId: string
): Promise<string> => {
  return await createNotification(
    instructorId,
    "payment_pending",
    "มีการแจ้งโอนเงินใหม่",
    `${studentName} แจ้งโอนเงินสำหรับคอร์ส "${courseTitle}" จำนวน ฿${amount.toLocaleString()}`,
    {
      courseId,
      paymentId,
      studentId,
      studentName,
      amount,
    }
  );
};
